import { render, staticRenderFns } from "./WameedSearchHeader.vue?vue&type=template&id=01cd8365&"
import script from "./WameedSearchHeader.vue?vue&type=script&lang=js&"
export * from "./WameedSearchHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports